import { jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from "react";
import { normalizeIANATimeZone, normalizeTimeZone } from "@chronosphereio/core";
import { StringParam, useQueryParam } from "use-query-params";
import { useDeepMemo } from "../../core/index.js";
const TimeZoneContext = /*#__PURE__*/ createContext(void 0);
function TimeZoneProvider(props) {
    const { children, userTimeZone, initialTimeZone, disableURLParams } = props;
    const defaultTimeZone = initialTimeZone ?? userTimeZone;
    const [timeZoneQueryParam, setTimeZoneQueryParam] = useQueryParam('timeZone', StringParam);
    const [timeZoneState, setTimeZoneState] = useState(defaultTimeZone);
    let timeZone = defaultTimeZone;
    if (disableURLParams) timeZone = timeZoneState;
    else if (timeZoneQueryParam) timeZone = timeZoneQueryParam;
    const setTimeZone = useCallback((newTimeZone)=>{
        const normalizedNewTimeZone = normalizeIANATimeZone(newTimeZone);
        const normalizedDefaultTimeZone = normalizeIANATimeZone(defaultTimeZone);
        if (disableURLParams) setTimeZoneState(newTimeZone);
        else normalizedNewTimeZone === normalizedDefaultTimeZone ? setTimeZoneQueryParam(null) : setTimeZoneQueryParam(newTimeZone);
    }, [
        disableURLParams,
        setTimeZoneQueryParam,
        defaultTimeZone
    ]);
    const ctx = useDeepMemo(()=>({
            userTimeZone,
            timeZone,
            setTimeZone
        }), [
        userTimeZone,
        timeZone,
        setTimeZone
    ]);
    return /*#__PURE__*/ jsx(TimeZoneContext.Provider, {
        value: ctx,
        children: children
    });
}
function useTimeZone() {
    const ctx = useContext(TimeZoneContext);
    return {
        userTimeZone: normalizeTimeZone(ctx?.userTimeZone),
        timeZone: normalizeTimeZone(ctx?.timeZone ?? ctx?.userTimeZone),
        setTimeZone: ctx?.setTimeZone
    };
}
export { TimeZoneContext, TimeZoneProvider, useTimeZone };

//# sourceMappingURL=TimeZoneProvider.js.map